import { Component, OnInit, AfterViewInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';

import { RoutePartsService } from "./shared/services/route-parts.service";
import { CheckForUpdateService } from "./shared/services/check-for-update.service";
import { PromptUpdateService } from "./shared/services/prompt-update.service";

// import { ThemeService } from './shared/services/theme.service';

import { filter } from 'rxjs/operators';
// import { LayoutService } from './shared/services/layout.service';
import { RecaptchaComponent } from 'ng-recaptcha';
import { SwUpdate } from '@angular/service-worker';
import { buildInfo } from 'environments/version';
import { environment } from 'environments/environment';

RecaptchaComponent.prototype.ngOnDestroy = function () {
  if (this.subscription) {
    this.subscription.unsubscribe();
  }
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
  private static readonly MAX_SAFE_COOKIE_LENGTH = 1800;

  appTitle = 'infokaw';
  pageTitle = 'Sistema de gestão';
  version = buildInfo.version;

  constructor(
    public title: Title,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private routePartsService: RoutePartsService,
    private swUpdate: SwUpdate,
    private checkForUpdateService: CheckForUpdateService,
    private promptUpdateService: PromptUpdateService,
    // private themeService: ThemeService,
    // private layout: LayoutService,
    // private renderer: Renderer2
  ) { }



  ngOnInit() {
    console.log(`VERSAO ${this.version} (${buildInfo.commit}) · ambiente ${(environment as any).name}`);
    this.cleanupOversizedCookies();
    

    this.changePageTitle();
  }
  ngAfterViewInit() {
  }
  changePageTitle() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((routeChange) => {
      var routeParts = this.routePartsService.generateRouteParts(this.activeRoute.snapshot);
      if (!routeParts.length)
        return this.title.setTitle(this.appTitle);
      // Extract title from parts;
      this.pageTitle = routeParts
        .reverse()
        .map((part) => part.title)
        .reduce((partA, partI) => { return `${partA} > ${partI}` });
      this.pageTitle += ` | ${this.appTitle}`;
      this.title.setTitle(this.pageTitle);
    });
  }

  private cleanupOversizedCookies() {
    try {
      const rawCookie = document.cookie || '';
      if (!rawCookie) {
        return;
      }

      rawCookie.split('; ').forEach(pair => {
        const separatorIndex = pair.indexOf('=');
        if (separatorIndex < 0) {
          return;
        }

        const name = decodeURIComponent(pair.substring(0, separatorIndex));
        const value = pair.substring(separatorIndex + 1);
        const isOversized = value.length > AppComponent.MAX_SAFE_COOKIE_LENGTH;

        if (isOversized) {
          this.deleteCookieEverywhere(name);
        }
      });
    } catch (e) {
      // Nao interrompe bootstrap em caso de erro na limpeza.
    }
  }

  private deleteCookieEverywhere(name: string) {
    const encodedName = encodeURIComponent(name);
    const expire = 'Thu, 01 Jan 1970 00:00:00 GMT';
    const host = window.location.hostname;
    const paths = ['/', '/jkawflex'];

    paths.forEach(path => {
      document.cookie = `${encodedName}=; expires=${expire}; path=${path}`;
      document.cookie = `${encodedName}=; expires=${expire}; path=${path}; domain=${host}`;
      document.cookie = `${encodedName}=; expires=${expire}; path=${path}; domain=.${host}`;
    });
  }

}
